import { PrismicNextImage } from '@prismicio/next';
import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Card,
  Avatar,
  Heading,
  CardTitle,
  Typography,
  CardContent,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { retrieveIcon } from '@/services/utils/icons';
import { avatarColour } from '@/services/utils/colour';
import { applicationEnv } from '@/services/env/shared';

export type WithPrivateRegionProps = {
  id: string;
  slice: Content.RegionComplexSliceWithPrivateRegion;
};

export const WithPrivateRegion = ({ id, slice }: WithPrivateRegionProps) => {
  const { primary } = slice;
  const { image, cards, title, eyebrow } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" addFlow>
      <Typography component="span" addEyebrow colour="primary">
        {asText(eyebrow)}
      </Typography>

      <Heading component="h2" addHeadlineTitle>
        {asText(title)}
      </Heading>

      <Box
        addSwitcher
        gap="gap-lg"
        component="div"
        style={{ ['--c6-switcher-vertical-alignment' as string]: 'center' }}
      >
        <Box component="div" addFlow>
          {cards.map((card, index) => {
            const response = avatarColour(card.avatar_colour);

            return (
              <Card
                variant="subtle"
                component="article"
                key={`private-region-${id}-${index + 1}`}
              >
                <CardContent addCluster addMediaObject addFlow>
                  {card.icon !== 'None' && (
                    <Avatar
                      colour={response?.colour}
                      variant={response?.variant}
                      icon={retrieveIcon(card.icon)}
                    />
                  )}
                  <Box component="div" addFlow>
                    <CardTitle component="h3">{asText(card.title)}</CardTitle>
                    <RichText
                      variant="default"
                      content={card.content}
                      websiteUrl={WebsiteUrl}
                    />
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>
        <figure className="feature-img">
          {isFilled.image(image) && <PrismicNextImage field={image} />}
        </figure>
      </Box>
    </Box>
  );
};
